
export enum ShipmentVolumeTypeCd {
	DENSITY_SHPMT = 'DensityShpmt',
	FOOTPRINT_PIECE_PRFL = 'FootprintPiecePrfl',
	HGHT_PIECE = 'HghtPiece',
	VOL_PIECE = 'VolPiece',
	VOL_SHPMT = 'VolShpmt'}

